import { actionTypes } from '../constants';

const initialState = {
    is_spinning: false,
    snackbar: null,
};

export default (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SPINNING_START:
            return {
                ...state,
                is_spinning: true,
            }
        case actionTypes.SPINNING_STOP:
            return {
                ...state,
                is_spinning: false,
            }
        case actionTypes.SNACKBAR:
            return {
                ...state,
                snackbar: action.snackbar,
            }
        case actionTypes.SNACKBAR_CLEAR:
            return {
                ...state,
                snackbar: null
            }
        default:
            return state;
    }
}
